import React from "react";
import ReactJson from "react-json-view";

import { longDateTime } from "../../utils/DateHelper";
import BaseModal from "./BaseModal";
import { useTranslation } from "react-i18next";

const ActivityDetailsModal = ({
    isVisible,
    setIsVisible,
    inputFields,
    textFields,
    data,
}) => {
    const { t } = useTranslation();

    const renderFields = () => {
        return (
            inputFields &&
            inputFields.map((field, index) => {
                return (
                    <div key={index} className="input-group m-0">
                        <label htmlFor={`input-${index}`} className="uppercase">
                            {field.label}
                        </label>
                        <input
                            type={field.type}
                            id={`input-${index}-${field.name}`}
                            className="input-element"
                            name={field.name}
                            value={
                                field.type === "datetime"
                                    ? longDateTime(data[field.name])
                                    : data[field.name] || "---"
                            }
                            readOnly
                        />
                    </div>
                );
            })
        );
    };

    const renderTextFields = () => {
        return (
            textFields &&
            textFields.map((field, index) => {
                return (
                    data[field.name] && (
                        <div key={index} className="input-group my-4">
                            <label htmlFor="note" className="uppercase">
                                {field.label}
                            </label>
                            {typeof data[field.name] === "object" ? (
                                <div className="basic-border rounded border-gray-300">
                                    <div className="p-3">
                                        <ReactJson
                                            src={data[field.name]}
                                            name={false}
                                            enableClipboard={false}
                                            displayDataTypes={false}
                                            style={{ fontSize: 12 }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <textarea
                                    value={data[field.name] || "---"}
                                    id={field.name}
                                    className="input-element textarea-element"
                                    readOnly
                                ></textarea>
                            )}
                        </div>
                    )
                );
            })
        );
    };

    return (
        <>
            <BaseModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                title={t("activityDetails")}
                titleIcon="fas fa-info-circle"
            >
                <div className="main-customer-form-inputs grid-2-cols">
                    {renderFields()}
                </div>
                <div>{renderTextFields()}</div>
            </BaseModal>
        </>
    );
};

export default ActivityDetailsModal;
